import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Field, reduxForm, formValueSelector, change, FormSection } from 'redux-form';
import { FormattedMessage } from 'react-intl';
import messages from '../../../../../../text/messages';
import { formSettings } from '../settings';
import { RadioField, PhoneField, TextField } from '../../../../../../components/fields';
import { required } from '../../../../../../utilities/validation';
import WizardButtons from '../../../../../../components/wizard/navigator/buttons';
import { saveAddress, getAddresses } from '../../../../../../reducers/addresses';
import { setProgressionProperties } from '../../../../../../reducers/onboarding';
import { updateUserDetails, updateUserProfile } from '../../../../../../reducers/identity';
import { parseAnswers, objectToFormInstanceValues, answersToSimpleInitialValues } from '../../../../../../utilities/formInstances';
import { calculateRegime, setJobProgress } from '../../../../../../reducers/jobs';
import ReclassificationForm from './assets/reclassificationForm';
import Modal from '../../../../../../components/modal';
import AddressComponent from '../../../../../../components/address';
import mixpanel from 'mixpanel-browser';
import { taxFields, taxType } from '../../../../../../utilities/regime';

class VendorInformationStep extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            modal: { open: false, data: undefined }
        };

        // modal controls
        this.onOpen = this.onOpen.bind(this);
        this.onClose = this.onClose.bind(this);

        this.submit = this.submit.bind(this);
        this.getRedirectStep = this.getRedirectStep.bind(this);
        this.redirectToW2 = this.redirectToW2.bind(this);
    }

    componentDidMount() {
        mixpanel.track('WorkerOnboarding', { _data: { branch: 'ic', step: 'VendorInformationStep' } });

        const { role, getAddresses, setProgressionProperties } = this.props;
        getAddresses(role, addresses => {
            if (addresses && addresses.length > 0) {
                setProgressionProperties({ mailingAddress: addresses[0] });
            }
        });
    }

    onOpen() {
        this.setState({ ...this.state, modal: { open: true } });
    }

    onClose(action) {
        if (action) {
            this.setState({ ...this.state, modal: { open: false }, data: undefined }, () => action());
        } else {
            this.setState({ ...this.state, modal: { open: false }, data: undefined });
        }
    }

    getRedirectStep() {
        const { job } = this.props;
        let step = 0;
        const { classify_client_pref } = job || {};
        switch (classify_client_pref) {
            case 'w2-only':
                step = 1;
                break;

            case 'ic-preferred':
            case 'w2-or-ic':
            case 'ic-only':
            default:
                step = 1;
                break;
        }

        return step;
    }

    scorePrequal(prequalify) {
        const { directed, onsite, otherClients, notEmployee, ownHours } = prequalify;
        const isTrue = p => p === true || p.toLowerCase() === 'true' || p.toLowerCase === 'yes';

        let score = 0;
        score += isTrue(notEmployee) ? 0 : -40;
        score += isTrue(onsite) ? -60 : 0;
        score += isTrue(directed) ? -60 : 0;
        score += isTrue(otherClients) ? 20 : 0;
        score += isTrue(ownHours) ? 0 : -40;

        return score;
    }

    submit(values, action) {
        const {
            role,
            details,
            profile,
            address,
            calculateRegime,
            updateUserDetails,
            updateUserProfile,
            saveAddress,
            setProgressionProperties,
            job
        } = this.props;
        const { company, mailingAddress, prequalify, linkedin_url } = values;

        const answers = parseAnswers(
            'preclassify_contractor',
            [{ id: 'directed' }, { id: 'otherClients' }, { id: 'notEmployee' }, { id: 'onsite' }, { id: 'ownHours' }],
            objectToFormInstanceValues(prequalify)
        );

        company.tax_id_type = taxType(company.business_type);
        company.VATIN_type = company.VATIN ? 'UK_VAT' : null;

        updateUserDetails(role, { ...details, ...company, preclassify_answers: { answers } }, () => {
            updateUserProfile({ ...profile, phone: company.phone, zip: mailingAddress && mailingAddress.zip, linkedin_url }, () =>
                saveAddress({ ...mailingAddress, ref_type: role.type, ref_id: role.id, id: address.id }, () => {
                    calculateRegime(job.id, regime => {
                        setProgressionProperties({ mailingAddress, regime });
                        if (this.scorePrequal(prequalify) <= -100) {
                            this.onOpen();
                            return;
                        }
                        action();
                    });
                })
            );
        });
    }

    redirectToW2() {
        const { changeField, job } = this.props;
        if (job.classify_client_pref === 'ic-only') {
            changeField(formSettings.form, 'contractType', 'dont-qualify-ic');
        } else {
            changeField(formSettings.form, 'contractType', 'w2');
        }
    }

    renderQuestion(name, placeholder, field) {
        const optionsTF = value => [
            {
                label: (
                    <React.Fragment>
                        <i className="material-icons">{value === 'true' || value === true ? 'radio_button_checked' : 'radio_button_unchecked'}</i>
                        <span>
                            <FormattedMessage {...messages.true} />
                        </span>
                    </React.Fragment>
                ),
                value: true
            },
            {
                label: (
                    <React.Fragment>
                        <i className="material-icons">{value === 'false' || value === false ? 'radio_button_checked' : 'radio_button_unchecked'}</i>
                        <span>
                            <FormattedMessage {...messages.false} />
                        </span>
                    </React.Fragment>
                ),
                value: false
            }
        ];

        return (
            <div className="row">
                <div className="col-xs-12">
                    <Field
                        name={name}
                        validate={required}
                        placeholder={placeholder}
                        component={RadioField}
                        options={optionsTF(field)}
                        selectedValue={field ? field : ''}
                    />
                </div>
            </div>
        );
    }

    render() {
        const { modal } = this.state;
        const { handleSubmit, onSubmit, back, next, submitting, job, client, progression, prequalify, businessType } = this.props;
        if (!progression) {
            return null;
        }

        const { directed, otherClients, notEmployee, onsite, ownHours } = prequalify;
        return (
            <div>
                <form onSubmit={handleSubmit(values => this.submit(values, onSubmit))}>
                    <div className="row">
                        <div className="col-md-9 col-sm-12">
                            <div className="row">
                                {taxFields(job.regime, businessType)}
                                <div className="col-md-7 col-sm-7 col-xs-12">
                                    <Field name="company.name" validate={required} component={TextField} placeholder={messages.businessName} />
                                </div>
                                <div className="col-md-5 col-sm-5 col-xs-12">
                                    <Field name="company.phone" validate={required} component={PhoneField} placeholder={messages.phoneNumber} />
                                </div>
                                <div className="col-md-7 col-sm-7 col-xs-12">
                                    <Field name="company.web_site" component={TextField} placeholder={messages.businessURL} />
                                </div>
                                <div className="col-md-5 col-sm-5 col-xs-12">
                                    <Field name="linkedin_url" component={TextField} placeholder={messages.linkedIn} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-12">
                            <FormattedMessage {...messages.businessAddress} tagName={'h5'} />
                        </div>
                        <div className="col-xs-12 col-sm-9">
                            <FormSection name={'mailingAddress'}>
                                <div className="row">
                                    <AddressComponent
                                        form={formSettings.form}
                                        section={'mailingAddress'}
                                        hideName={true}
                                        countries={client.countries}
                                        oneLineAddress={true}
                                    />
                                </div>
                            </FormSection>
                        </div>
                    </div>

                    <div className="row section">
                        <div className="col-xs-12">
                            <div className="form-generator">
                                {this.renderQuestion('prequalify.notEmployee', { ...messages.prequalifyNotEmployee, values: { co: client.name } }, notEmployee)}
                                {this.renderQuestion('prequalify.onsite', { ...messages.prequalifyOnsite, values: { co: client.name } }, onsite)}
                                {this.renderQuestion('prequalify.directed', { ...messages.prequalifyDirected, values: { co: client.name } }, directed)}
                                {this.renderQuestion(
                                    'prequalify.otherClients',
                                    { ...messages.prequalifyOtherClients, values: { co: client.name } },
                                    otherClients
                                )}
                                {this.renderQuestion('prequalify.ownHours', { ...messages.prequalifyOwnHours, values: { co: client.name } }, ownHours)}
                            </div>
                        </div>
                    </div>

                    <WizardButtons disabled={submitting} back={{ action: back }} />
                </form>

                <Modal
                    open={modal.open}
                    onClose={this.onClose}
                    managedClose
                    size="col-xs-12 col-sm-8 col-sm-offset-2"
                    title={<FormattedMessage id={'yourClassification'} defaultMessage={'Employment Classification'} />}
                >
                    <ReclassificationForm
                        icOnly={job && job.classify_client_pref === 'ic-only'}
                        onSubmit={() => this.onClose(() => next(this.getRedirectStep(), job.id, 'w2', this.redirectToW2))}
                    />
                </Modal>
            </div>
        );
    }
}

VendorInformationStep = reduxForm(formSettings)(VendorInformationStep);

const selector = formValueSelector('contractor-onboarding-wizard');
const mapStateToProps = state => {
    const profile = state.identity.profile;

    let progression = state.onboarding.progression;
    let details = state.identity.details;
    let questionAnswers = details.preclassify_answers ? answersToSimpleInitialValues(details.preclassify_answers.answers) : undefined;
    const address = state.addresses.list.length ? state.addresses.list[0] : {};
    const company = { ...details, phone: profile.phone };
    return {
        role: state.identity.role,
        businessType: selector(state, 'company.business_type') ? selector(state, 'company.business_type') : '',
        details,
        profile: state.identity.profile,
        client: state.onboarding.client,
        prequalify: selector(state, 'prequalify') ? selector(state, 'prequalify') : {},
        progression,
        address,
        job: state.jobs.list[0],
        initialValues: {
            linkedin_url: profile.linkedin_url,
            company,
            mailingAddress: progression ? progression.mailingAddress : undefined,
            prequalify: questionAnswers ? questionAnswers : undefined
        }
    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            changeField: change,
            updateUserDetails,
            updateUserProfile,
            setJobProgress,
            saveAddress,
            getAddresses,
            setProgressionProperties,
            calculateRegime
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(VendorInformationStep);



// WEBPACK FOOTER //
// ./src/pages/onboarding/tenants/contractor/steps/contractor/vendorInformation.jsx